import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAssortmentSelectedCategory } from 'partner360/features/assortment/selectors'

import { AssortmentSidePanel } from './components/assortmentSidePanel/AssortmentSidePanel'
import { EditConfirmDialog } from './components/editConfirmDialog/EditConfirmDialog'
import { CategoryAssortmentContent } from './components_v2/categoryAssortmentContent/CategoryAssortmentContent'
import { IAssortmentTabProps } from './models/IAssortmentTabProps'

import styles from './AssortmentTab.module.scss'

export const AssortmentTab: FC<IAssortmentTabProps> = ({
  isEmbedded = false,
  partnerId,
  programType,
  category,
  isApplicableCategory = 1,
  fYear,
}) => {
  const selectedCategory = useSelector(selectAssortmentSelectedCategory)
  const categoryName = useMemo(() => {
    if (isEmbedded) {
      return category || null
    }

    if (selectedCategory) {
      return selectedCategory.Title
    }

    return null
  }, [isEmbedded, category, selectedCategory])

  const isApplicable = useMemo(() => {
    if (isEmbedded) {
      return isApplicableCategory === 1
    }

    if (selectedCategory) {
      return selectedCategory.IsApplicable === 1
    }

    return true
  }, [isEmbedded, isApplicableCategory, selectedCategory])

  return (
    <P360Card fullHeight bodyClassName={styles.cardWrapper} disabled={isEmbedded}>
      <div className={styles.root}>
        {!isEmbedded && (
          <AssortmentSidePanel partnerId={partnerId} programType={programType} fYear={fYear} />
        )}
        {categoryName !== null && (
          <CategoryAssortmentContent
            isEmbedded={isEmbedded}
            partnerId={partnerId}
            programType={programType}
            fYear={fYear}
            selectedCategory={categoryName}
            isApplicable={isApplicable}
          />
        )}
      </div>
      <EditConfirmDialog />
    </P360Card>
  )
}
